import { render, staticRenderFns } from "./PlayerArea.vue?vue&type=template&id=5df1583b&scoped=true"
import script from "./PlayerArea.vue?vue&type=script&lang=js"
export * from "./PlayerArea.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/player-area.css?vue&type=style&index=0&id=5df1583b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df1583b",
  null
  
)

export default component.exports